var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"dash-line",attrs:{"width":"100%","height":"1","xmlns":"http://www.w3.org/2000/svg","version":"1.1"}},[_c('rect',{style:({ 'stroke-opacity': _vm.strokeOpacity }),attrs:{"width":"100%","height":"100%","fill":"none","stroke":_vm.stroke,"stroke-width":"3","stroke-dasharray":"4, 14","stroke-linecap":"square"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }